import { AppContext } from "App";
import Page from "components/base/Page";
import { useContext } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { MANAGE_EDITOR_PARTIAL } from "utils/permissions";
import Accounts from "./accounts";
import ProductLines from "./products/All/ProductLines";
import Products from "./products/All/Products";
import { LeftButtons } from "./products/Header";
import ProductDetailPage from "./products/ProductDetail";

function ManageIndex() {
  const { hasPermission } = useContext(AppContext);

  if (hasPermission(MANAGE_EDITOR_PARTIAL))
    return (
      <Routes>
        <Route element={<Layout />}>
          <Route path="products" element={<Products />} />
          <Route path="product-lines" element={<ProductLines />} />
        </Route>
        <Route path="products/:id" element={<ProductDetailPage />} />
        <Route path="accounts" element={<Accounts />} />
        <Route path="*" element={<Navigate to="products" />} />
      </Routes>
    );

  return (
    <div className="flex flex-1 items-center justify-center font-bold text-2xl h-screen text-gray-600">
      Not Allowed.
    </div>
  );
}

const Layout = () => (
  <Page leftButtons={<LeftButtons />} className="lg:h-screen">
    <Outlet />
  </Page>
);

export default ManageIndex;
